import React, { useState, Suspense } from 'react';
import { Container, Row, Col, Form, Button, Toast } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Contact.css';

const LazyMap = React.lazy(() => import('./LazyMap'));

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://proresumecraftersbackend.onrender.com/send_message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
      });

      if (response.ok) {
        setToastMessage('Message successfully sent');
        setShowToast(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setToastMessage('Failed to send the message. Please try again.');
        setShowToast(true);
      }
    } catch (error) {
      setToastMessage('An error occurred while sending the message.');
      setShowToast(true);
    }
  };

  return (
    <Container className="contact-container">
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        style={{ position: 'fixed', top: '80px', left: '50px' }} 
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
      <Row className="contact-row">
        <Col md={6} className="contact-form-col">
          <Form className="contact-form" onSubmit={handleSubmit}>
            <h2>Contact For Any Queries</h2>
            <Form.Group className="mb-3">
              <Form.Control type="text" placeholder="Full Name" name="name" value={formData.name} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="email" placeholder="Email Address" name="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="text" placeholder="Subject" name="subject" value={formData.subject} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control as="textarea" rows={3} placeholder="Message" name="message" value={formData.message} onChange={handleChange} required />
            </Form.Group>
            <Button variant="primary" type="submit" className="submit-btn">
              Send Email
            </Button>
          </Form>
        </Col>
        <Col md={6} className="contact-map">
          <Suspense fallback={
            <div className="video-loading-container">
              <video autoPlay loop muted className="video-loading">
                <source src="/Loading-video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          }>
            <LazyMap />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
